import React, { Component } from 'react';
import { Glyphicon } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';
import config from '../config';
import { trackContactSent } from '../analytics';
import './Contact.css';

const MIN_NAME_LENGTH = 3;
const MIN_PHONE_DIGITS = 8;
const MIN_MESSAGE_LENGTH = 10;
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

const MESSAGES = {
  success: "Mensaje enviado exitosamente. Nos comunicaremos contigo prontamente.",
  network: "No pudimos conectar con el servicio. Revisa tu conexión e inténtalo nuevamente.",
  rejected: "No pudimos enviar el mensaje. Por favor inténtalo nuevamente o escríbenos a contacto@mapseguros.cl."
};

const EMPTY_FORM = { name: '', email: '', phone: '', message: '', captchaToken: '' };

class Contact extends Component {
  constructor(props) {
    super(props);
    this.recaptchaRef = React.createRef();
    this.state = {
      ...EMPTY_FORM,
      isLoading: false,
      alert: null,
      errors: {}
    };
  }

  handleChange = event => {
    this.setState({ [event.target.id]: event.target.value });
  }

  handleCaptchaChange = token => {
    this.setState({ captchaToken: token || '' });
  }

  validate() {
    const { name, email, phone, message, captchaToken } = this.state;
    const phoneDigits = phone.replace(/\D/g, '');
    const errors = {};
    if (name.trim().length < MIN_NAME_LENGTH) errors.name = "Debes ingresar tu nombre";
    if (!EMAIL_PATTERN.test(email.trim())) errors.email = "Debes ingresar un email válido";
    if (phoneDigits.length < MIN_PHONE_DIGITS) errors.phone = "Debes ingresar un teléfono válido";
    if (message.trim().length < MIN_MESSAGE_LENGTH) errors.message = "Debes ingresar el mensaje";
    if (!captchaToken) errors.captcha = "Debes confirmar que no eres un robot";
    return errors;
  }

  handleSubmit = async event => {
    event.preventDefault();
    const errors = this.validate();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }
    this.setState({ errors: {}, alert: null, isLoading: true });
    try {
      await this.sendContact();
      trackContactSent();
      this.setState({ ...EMPTY_FORM, isLoading: false, alert: { type: 'success', text: MESSAGES.success } });
    } catch (error) {
      this.setState({ isLoading: false, alert: { type: 'danger', text: error.userMessage || MESSAGES.rejected } });
    } finally {
      this.resetCaptcha();
    }
  }

  async sendContact() {
    const { name, email, phone, message, captchaToken } = this.state;
    let response;
    try {
      response = await fetch(config.url.api + '/contact', {
        method: 'POST',
        body: JSON.stringify({ name, email, phone, message, key: captchaToken }),
        headers: { 'Content-Type': 'application/json' }
      });
    } catch (networkError) {
      throw Object.assign(new Error(networkError.message), { userMessage: MESSAGES.network });
    }
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    const body = await response.json().catch(() => ({}));
    if (body.code !== undefined && body.code !== 0) {
      throw Object.assign(new Error(body.message || 'rejected'), { userMessage: body.message });
    }
  }

  resetCaptcha() {
    if (this.recaptchaRef.current) {
      this.recaptchaRef.current.reset();
    }
    this.setState({ captchaToken: '' });
  }

  handleAlertClose = () => {
    this.setState({ alert: null });
  }

  renderField(id, label, type = "text") {
    const error = this.state.errors[id];
    const className = "form-control" + (error ? " is-invalid" : "");
    const commonProps = { id, value: this.state[id], placeholder: label, className, onChange: this.handleChange, disabled: this.state.isLoading };
    return (
      <div className="form-group">
        <label htmlFor={id} className="sr-only">{label}</label>
        {type === "textarea"
          ? <textarea {...commonProps} cols="30" rows="5" />
          : <input {...commonProps} type={type} />}
        <div className="help-block with-errors">
          {error && <div className="invalid-feedback">{error}</div>}
        </div>
      </div>
    );
  }

  render() {
    const { alert, errors, isLoading } = this.state;
    return (
      <section id="contact" className="contact-area ptb-100">
        <div>
          <div className="row">
            <div className="col-lg-5 col-md-12">
              <div className="contact-content">
                <h3>Déjanos un mensaje</h3>
                <p>Si quieres consultar por tu seguro, necesitas asesoría u otro motivo completa el formulario y te contactamos a la brevedad.</p>
                <div className="mail-content">
                  <p>Correo de contacto</p>
                  <a href="mailto:contacto@mapseguros.cl">
                    <Glyphicon className="mail" glyph="envelope" /> contacto@mapseguros.cl <Glyphicon className="mail" glyph="envelope" />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-7 col-md-12">
              <form id="contactForm" className="home-contact-form" onSubmit={this.handleSubmit} noValidate>
                <div className="row2">
                  <div className="col-lg-12 col-md-12">
                    {this.renderField("name", "Nombre")}
                  </div>
                  <div className="col-lg-6 col-md-6">
                    {this.renderField("phone", "Teléfono", "tel")}
                  </div>
                  <div className="col-lg-6 col-md-6">
                    {this.renderField("email", "E-mail", "email")}
                  </div>
                  <div className="col-lg-12 col-md-12">
                    {this.renderField("message", "Mensaje", "textarea")}
                  </div>
                  <div className="col-lg-12 col-md-12">
                    <div className="form-group recaptcha">
                      <ReCAPTCHA ref={this.recaptchaRef} sitekey={config.reCaptchaSiteKey} onChange={this.handleCaptchaChange} hl="es" />
                      <div className="help-block with-errors">
                        {errors.captcha && <div className="invalid-feedback">{errors.captcha}</div>}
                      </div>
                    </div>
                  </div>
                  {alert &&
                    <div className={"alert alert-" + alert.type + " col-lg-12 col-md-12"} role="alert">
                      {alert.text}
                      <button type="button" className="close" aria-label="Cerrar" onClick={this.handleAlertClose}>
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  }
                  <div className="col-lg-12 col-md-12">
                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                      {isLoading ? "Enviando..." : "Enviar Mensaje"}
                    </button>
                    <div className="clearfix"></div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js